import dispatchComponent from "./DispatchCompoent";

export class BaseViewModelClass<T> {
    setState: ((Details: T) => void) = () => {};
    loading: boolean = true
    error?: string
    notFound?: boolean = false

    _OriginalState? : T
    constructor(item: T){
        this._ItemActivo = item 
        this.loading= false
    }
    //Esto solo srive para manejar la lógica, si se quiere mostrar algo en la UI se necesita usar el [state] con el que está vinculado this.setState 
    public _ItemActivo: T 
    
    public setItemActivo(value : T) {
        this._ItemActivo = value;
        this.NotifyPropertyChanged()
    }
    public NotifyPropertyChanged(){
        if(this.setState === undefined)
            throw new Error("No se ha definido el método setState")
        if(this._ItemActivo === undefined)
            throw new Error("No se ha encontrado el itemActivo")
        this.setState(this._ItemActivo)
    }
    DefinirSetState(funcion: (props: T) => void){
        this.setState = funcion
    };
    public sendDispatch(payload: any){
        const resultado = dispatchComponent(payload)
    }
    public puedeGuardar: boolean = true
}